<template>
  <tr>
    <td data-cy="columnEmail">
      {{ item.email }}
    </td>
    <td data-cy="columnName">
      {{ item.username }}
    </td>
    <td data-cy="columnAccountId">
      {{ item.accountId }}
    </td>
    <td data-cy="columnSubscription">
      {{ item.subscription }}
    </td>
    <td data-cy="columnSapAcctId">
      {{ item.sapAcctId }}
    </td>
    <td data-cy="columnLastLogin">
      <div v-if="Number(item.lastLogIn) !== 0" class="valid-date">
        {{ new Date(item.lastLogIn).toLocaleString() }}
      </div>
    </td>
    <td class="text-right">
      <AccountActionMenu
        :accountId="item.accountId"
        :userId="item.userId"
        :sapId="item.sapAcctId"
        :email="item.email"
      />
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type { AdminPanelAccountRow } from '@/store/adminpanel'
import AccountActionMenu from './accountActionMenu.vue'

export default defineComponent({
  name: 'AccountTableBody',
  props: {
    item: { type: Object as PropType<AdminPanelAccountRow>, required: true }
  },
  components: {
    AccountActionMenu
  }
})
</script>
